import { AfterViewInit, Component, OnInit, ElementRef, Renderer2 } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { NavigateRoutes, RequestType, StorageConstants, TransactionStatus } from 'common/constants/app.constant';
import { RouteMessage } from 'common/models/utilitymodels/base.model';
import { QueryParams } from 'common/models/utilitymodels/list.model';
import { HttpService } from 'common/services/core_services/http.service';
import { SystemService } from 'common/services/core_services/system.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'bh-desktop-header',
    templateUrl: './desktop-header.component.html',
})
export class DesktopHeaderComponent implements OnInit, AfterViewInit {
    transactionType = TransactionStatus;
    userProfile: any = null;
    loggedIn: boolean = false;
    routeSubscription: Subscription;
    pendingTransaction: number = 0;
    rightSectionToshow: 'user' | 'loginbtn' | '' = '';
    deviceWidth: number;
    isLoginPage: boolean = false;
    showHeader: boolean = true;
    pendingTransCount: string = '0';

    constructor(private router: Router, public systemService: SystemService) { }

    ngOnInit() {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                if (event.url.includes(NavigateRoutes.viewContent) && this.systemService.deviceInfo.platform === 'web') {
                    this.showHeader = false;
                } else if ([NavigateRoutes.loginViaOtp, NavigateRoutes.welcome, NavigateRoutes.viewContent].includes(event.url) && this.systemService.deviceInfo.platform !== 'web') {
                    this.showHeader = false;
                } else {
                    this.showHeader = true;
                }
                this.userProfile = this.systemService.getLocalStorage(StorageConstants.userProfile) ? JSON.parse(this.systemService.getLocalStorage(StorageConstants.userProfile)) : null;
                if (this.systemService.getLocalStorage(StorageConstants.userProfile)) {
                    this.userProfile = JSON.parse(this.systemService.getLocalStorage(StorageConstants.userProfile));
                    this.rightSectionToshow = 'user';
                } else {
                    this.rightSectionToshow = 'loginbtn';
                }
            }
        });
    }

    ngAfterViewInit(): void {
        this.systemService.ispendingTransctionUpdate.subscribe((value) => {
            if (typeof parseInt(value) === 'number') this.pendingTransCount = this.onPendingTransactionDisplay(+value);
        });
    }
    routeToProfileorDashboard(routeTo: 'profile' | 'dashboard') {
        const isEmployeeLogin = JSON.parse(this.systemService.getLocalStorage(StorageConstants.isEmployeeLogin));
        if (isEmployeeLogin) {
            return;
        }

        const routeMessage = new RouteMessage();
        routeMessage.type = routeTo === 'profile' ? RequestType.GET : RequestType.ID;
        routeMessage.transferData = this.userProfile;
        if (routeTo === 'profile' && this.router.url === NavigateRoutes.distributordashboard) {
            routeMessage.transferData.fromDashBoard = true;
        }
        this.systemService.routeByUrl(routeTo === 'profile' ? NavigateRoutes.distributorprofile : NavigateRoutes.distributordashboard, routeMessage);
    }

    onProfileImageError(event: Event): void {
        const target = event.target as HTMLImageElement;
        target.src = 'assets/icon/profile_img_on_error.svg';
    }

    clickLogo() {
        // if (this.showHeader) {
        const routeMessage = new RouteMessage();
        if (this.systemService.getLocalStorage(StorageConstants.userProfile)) {
            routeMessage.type = RequestType.ID;
            this.systemService.routeByUrl(NavigateRoutes.distributordashboard, routeMessage);
        } else {
            routeMessage.type = RequestType.GET;
            this.systemService.routeByUrl(NavigateRoutes.welcome, routeMessage);
        }
        // }
    }

    onPendingTransactionDisplay(count: number) {
        if (count === null) {
            return '0';
        }
        return count <= 99 ? count.toString() : '99+';
    }

    goToLoginRegister(type: 'login' | 'register') {
        const routeMsg = new RouteMessage();
        routeMsg.type = RequestType.BLANK;
        routeMsg.transferData = null;
        this.systemService.routeByUrl(type === 'register' ? NavigateRoutes.baselogin : NavigateRoutes.loginViaOtp, routeMsg);
    }

    goToTransaction() {
        const routeMsg = new RouteMessage();
        routeMsg.type = RequestType.BLANK;
        routeMsg.transferData = null;
        this.systemService.routeByUrl(NavigateRoutes.preLoginTransaction, routeMsg);
    }

    goToEmpanelment(type: 'empanelment') {
        const routeMsg = new RouteMessage();
        routeMsg.type = RequestType.BLANK;
        routeMsg.transferData = null;
        this.systemService.routeByUrl(NavigateRoutes.empanelment, routeMsg);
    }

    // navigateToPendingTransaction() {
    //     const routeMsg = new RouteMessage();
    //     routeMsg.transferData = null;
    //     let link = '';
    //     routeMsg.type = RequestType.GET;
    //     routeMsg.transferData = new QueryParams();
    //     link = NavigateRoutes.transactionHistory;
    //     this.systemService.routeByUrl(NavigateRoutes.pendingTransaction, routeMsg);
    // }

    onLogOut() {
        // this.userLogsService.saveDetails(JSON.parse(this.systemService.getLocalStorage(StorageConstants.userProfile)), 'logout', '');
        this.systemService.isTransactionRouteForPopup = false;
        if (this.systemService.deviceInfo.platform !== 'web') {
            // this.modalService.dismissAll();
            this.systemService.storageService
                .clearStorage()
                .then(() => {
                    const routeMessage = new RouteMessage();
                    routeMessage.type = RequestType.BLANK;
                    this.systemService.routeByUrl(NavigateRoutes.loginViaOtp, routeMessage);
                })
                .catch((err) => {
                    this.systemService.showToaster('On Logoubt Something Went Wrong', 'error');
                });
        } else {
            this.systemService.logOut();
        }
    }
}
